module.exports = __webpack_public_path__ + "static/media/MMTC-PAMP-offer.f5505c0b.png";